export default "__VITE_ASSET__DGr8jcz7__"